// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Load } from './load';
import { Product } from './product';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class LoadAdditive extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  abbreviation?: string;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  displayOrder?: number;
  loadId!: number;
  loadYards!: number;
  name?: string;
  orderAccum!: number;
  placeholder1!: number;
  placeholder2!: number;
  price!: number;
  productId?: number;
  quantityOrdered!: number;
  load!: Load;
  product!: Product;
}

